<template>
  <layout-auth message="Reset Password">
    <form-field-input
      label="Email"
      :validation-errors="validationErrors.email"
      v-model="resetPasswordForm.email"
      size=""
      type="email"
      v-autofocus
      readonly
    ></form-field-input>

    <form-field-password
      label="Password"
      :validation-errors="validationErrors.password"
      v-model="resetPasswordForm.password"
      size=""
    ></form-field-password>

    <form-field-password
      label="Confirm Password"
      :validation-errors="validationErrors.password"
      v-model="resetPasswordForm.password_confirmation"
      size=""
    ></form-field-password>

    <button-default
      class="auth_button"
      size=""
      :disabled="isResetting"
      :loading="isResetting"
      @click="submitRequestFrom"
    >Reset Password</button-default>
  </layout-auth>
</template>

<script>
import auth from "../../api/auth";
import router from "../../router";

export default {
  name: "PasswordReset",
  metaInfo: {
    title: "Password Reset"
  },
  data() {
    return {
      isResetting: false,
      resetPasswordForm: {
        token: window.location.pathname.split('/').pop(),
        email: decodeURIComponent(window.location.search.split('?email=').pop()),
        password: null,
        password_confirmation: null,
      },
      validationErrors: {},
    }
  },
  mounted() {
    document.getElementById('js-initial-password-field').focus();
  },
  methods: {
    submitRequestFrom() {
      this.isResetting = true;
      auth.resetPassword(this.resetPasswordForm).then(() => {
        router.push({ name: 'user-dashboard' });
      }).catch((error) => {
        if (error.response.status === 422) this.validationErrors = error.response.data.errors;
        this.isResetting = false;
      });
    }
  }
}
</script>
